import { Inject, Injectable } from '@angular/core';
import { User } from '@models/user.model';
import { NgxCrudService } from '@sinapsys/ngx-crud';
import { INTESTAZIONE_CARICAMENTO } from './caricamento.interceptor';
import { Observable, map } from 'rxjs';
import { COMMON_APP_CONFIG } from '../tokens/common-config.token';

@Injectable({
  providedIn: 'root',
})
export class UsersService extends NgxCrudService<User, number> {
  constructor(@Inject(COMMON_APP_CONFIG) private mainConfig: Required<{ api: { apiBaseUrl: string } }>) {
    super({ apiBaseUrl: '' });
    this._baseUrl += this.mainConfig.api.apiBaseUrl + 'settings/users/';
  }

  getAutocomplete(sq: string): Observable<User[]> {
    return this.search({ $or: { email: { $like: sq }, first_name: { $like: sq }, last_name: { $like: sq }, blogger: { $like: sq } } }).pipe(
      map((c) => c.items.map((c) => new User(c)))
    );
  }

  /**
   * Segna l'ultimo accesso.
   *
   * E' manutenzione che parte da sola quando si apre la dashboard: non deve
   * mettersi davanti alla pagina come farebbe una scrittura chiesta
   * dall'utente. Stesso indirizzo e stesso verbo di `save`, solo senza velo.
   */
  registraAccesso(utente: User): Observable<User> {
    const { id, ...dati } = { ...utente, last_login: new Date() };
    return this.http.put<User>(this._baseUrl + id, dati, {
      responseType: 'json',
      withCredentials: true,
      headers: { [INTESTAZIONE_CARICAMENTO]: 'silenzioso' },
    });
  }

  uploadAvatar(base64Img: string, fileName: string): Observable<{ url: string; message: string }> {
    return this.http.post<{ url: string; message: string }>(this._baseUrl + 'upload-avatar', { base64Img, fileName });
  }
}
